import React from "react";
import Link from "next/link";
import styles from "./index.module.scss";

export default function Tags({ items = [] }) {
  return (
    <div className={styles.container}>
      {items.map((item, i) => (
        <Link href={"/blog/tag/" + item.identifier} key={i}>
          <a className={`${styles.tag}`}>{item.title}</a>
        </Link>
      ))}
    </div>
  );
}
